import * as v from "valibot";
import { rpcContract } from "../rpc";

export const stopLiveEventRpcContract = rpcContract({
  name: "stop-live-event",
  paramsSchema: v.object({
    event_id: v.string(),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    message: v.optional(v.string()),
  }),
});

export type StopLiveEventParams = v.InferOutput<(typeof stopLiveEventRpcContract)["paramsSchema"]>;
export type StopLiveEventResult = v.InferOutput<(typeof stopLiveEventRpcContract)["resultSchema"]>;
